import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, Button, Input, Label } from 'reactstrap'
import { useAddEditSessionMutation } from './processApiSlice'
import { useSnackbar } from 'notistack'
import { setSession } from './processSlice'
import { useDispatch } from 'react-redux'
import { setSessionProcess } from 'features/public-views/login/loginSlice'

const ModalEditSession = ({ isOpen, toggle, title, sessionProcess }) => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const [labelSession, setLabelSession] = useState(title ?? null)
  const [addOrEditSession, response] = useAddEditSessionMutation()

  useEffect(() => {
    if (isOpen) setLabelSession(title ?? '')
  }, [isOpen, title])

  const onConfirm = async () => {
    try {
      const res = await addOrEditSession({ title: labelSession })
      if (res?.error) {
        throw res
      }

      dispatch(setSessionProcess({ ...sessionProcess, ...res?.data }))
      enqueueSnackbar('ID Sesi berhasil diubah.', {
        variant: 'success',
      })
      toggle()
    } catch (error) {
      enqueueSnackbar(error?.message ?? error?.error?.data?.message, {
        variant: 'error',
      })
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered data-testid="process-edit-session-modal">
      <ModalBody>
        <h6 className="fw-semibold">Ubah ID Sesi</h6>
        <Label className="my-1" for="labelSession">
          ID Sesi
        </Label>
        <Input
          id="labelSession"
          rows="3"
          placeholder="Ubah ID sesi..."
          value={labelSession}
          onChange={(e) => setLabelSession(e.target.value)}
          className="mb-3"
          data-testid="process-edit-session-input"
        />
      </ModalBody>

      <ModalFooter className="border-0">
        <Button
          className="btn-cancel"
          color="secondary"
          onClick={toggle}
          data-testid="process-edit-session-cancel-button"
        >
          Batal
        </Button>
        <Button
          color="primary"
          onClick={onConfirm}
          data-testid="process-edit-session-submit-button"
        >
          Simpan
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ModalEditSession
